import styled from "styled-components";
import { getTheme, Flow, } from "@bracket/ui";
import type { FunctionComponent, ReactNode, } from "react";


export declare type PageWrapperProps = {
	children?: ReactNode;
};

export const PageWrapper: FunctionComponent<PageWrapperProps> = ({
	children,
	...props
}) => {
	return <PageFrame {...props}>{children}</PageFrame>;
};

export const PageFrame = styled(Flow)`
	width: 100%;
	padding: 1rem;
	color: ${() => getTheme().surface_on};
	font-family: ${() => getTheme().fonts.body};
	margin-top: 0px;

	// desktop below.
	@media(min-width: 1024px) {
		padding-top: 2rem;
		gap: 24px;
	}
`;
